import "react-toastify/dist/ReactToastify.css";
import { CsvUploader } from "@common/UploadCsvTemplate";
import LoadingIcon from "@common/LoadingIcon";
import { contactHeaderMapping } from "@services/TranslateCsvHeaders";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { expectedContactHeaders } from "@constants/CsvHeaders";
import { sampleContactData } from "@constants/SampleData";
import { UseKakelyCsvUpload } from "@pages/KAKELY/KakelyCsvUploadPage/hooks/useKakelyCsvUpload";
import { useParams } from "react-router-dom";
import { useState } from "react";

type ContactCsvUpdatePageProps = {
  id?: string;
};

const ContactCsvUploadPage: React.FC = ({
  id: propId,
}: ContactCsvUpdatePageProps) => {
  const { id: paramId } = useParams<{ id: string }>();
  const effectiveId = propId || paramId;
  const form = UseKakelyCsvUpload();

  const [isInternal] = useState(effectiveId === "internal");

  return (
    <div className="relative">
      {(form.loading || form.isProcessing) && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-5 rounded-lg shadow-lg flex items-center justify-center">
            <LoadingIcon
              bodyText={
                form.isProcessing
                  ? `${form.procesedCount || 0} / ${form.csvData.length || 0}`
                  : ""
              }
              footerText={messages.csv.do_not_close}
            />
          </div>
        </div>
      )}
      <CsvUploader
        titleText={
          isInternal
            ? pageHeaders.KAKELY.csvUploadInternal
            : pageHeaders.KAKELY.csvUploadExternal
        }
        uploadHandler={() => form.handleCsvUpload(isInternal ? 3 : 2)} // 2 for EXTERNAL, 3 for INTERNAL_NO_LOGIN
        onCancel={form.onCancel}
        csvData={form.csvData}
        setCsvData={form.setCsvData}
        sampleData={sampleContactData}
        failedUsers={form.failedUsers}
        templateName={`電話帳用CSVサンプル_${form.currentDate}`}
        headerMapping={contactHeaderMapping}
        fromPage={"contact"}
      />
    </div>
  );
};

export default ContactCsvUploadPage;
